module.exports = __webpack_public_path__ + "static/img/null_img_pjlt.e3084e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persondata/null_img_pjlt.png
// module id = 8kU0
// module chunks = 1